import {DI_TOKENS} from '@/di/di.tokens';

import axios from 'axios';
import {injected} from 'brandi';

import {AxiosHttpAdapter, HttpClient, HttpRetry} from '@specials/project-user';

import {Envs} from '@/types';

export class HttpClientProjectApi extends HttpClient {
  constructor(private readonly envs: Envs) {
    super(
      new AxiosHttpAdapter(
        axios.create({
          baseURL: envs.APP_PROJECT_API_URL,
        }),
      ),
      new HttpRetry(),
    );
  }
}

injected(HttpClientProjectApi, DI_TOKENS.envs);
